const styles = {
  button: {
    color: theme => theme.palette.primary.dark,
  },
  statesMenu: {
    '& .MuiList-root': {
      py: 0.25,
    },
    '& .MuiMenuItem-root': {
      px: 1,
      py: 1,
      '&:hover': {
        '& .MuiCheckbox-root': {
          color: theme => theme.palette.primary.main,
        },
      },
    },
    '& .MuiFormControlLabel-root': {
      alignItems: 'center',
    },
    '& .MuiCheckbox-root': {
      mr: 1.5,
    },
  },
  buttonContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    width: '100%',
  },
}

export default styles
